<template>
    <div>
        <portal-target name="dropdown" slim />
        <div class="flex flex-col" @click="hideDropdownMenus">
            <div class="h-screen flex flex-grow overflow-hidden bg-gray-100">
                <main-menu :url="url()" class="bg-teal-800 flex-no-shrink w-18 md:w-48 block overflow-y-auto" />

                <div id="layoutcontent" class="w-full h-full overflow-hidden py-5 overflow-y-auto mb-10 outline-none" tabindex="0" scroll-region>
                    <div class="px-10 pb-10">
                        <flash-messages></flash-messages>
                        <slot />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FlashMessages from "@/admin/Shared/FlashMessages";
import MainMenu from "@/admin/Shared/MainMenu";

export default {
    components: {
        FlashMessages,
        MainMenu
    },
    data() {
        return {
            showUserMenu: false,
            accounts: null
        };
    },
    methods: {
        url() {
            return location.pathname.substr(1);
        },
        hideDropdownMenus() {
            this.showUserMenu = false;
        }
    }
};
</script>
